export default __webpack_public_path__ + "static/media/logo-bl.8bc8baec.svg";